 <template>
  <div class="add-order">
    <el-form ref="form" label-width="150px">
      <el-row class="form-title">基础信息</el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="返利使用规则名称">{{detailData.name}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="返利使用规则编码">{{detailData.code}}</el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="使用规则有效期">{{(detailData.effectiveStartDate||'').slice(0,10)}} - {{(detailData.effectiveEndDate||'').slice(0,10)}}</el-form-item>
        </el-col>
        <!-- <el-col :span="12"> todo
          <el-form-item label="使用金额限制">每吨使用返利金额不超过{{detailData.rules[0]?.amount }}元</el-form-item>
        </el-col> -->
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="备注">{{detailData.remark}}</el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-card class="form-card" v-for="(item, index) in detailData.rules" :key="index">
      <el-row class="form-top">适用商品
      </el-row>
      <el-table
        :data="item.showGoodsList"
        style="width: 100%">
        <el-table-column
          label="商品名称"
          prop="itemName">
        </el-table-column>
        <el-table-column
          label="商品编码"
          prop="itemCode">
        </el-table-column>
      </el-table>
      <el-pagination
        :page-sizes="[10, 20, 50, 100]"
        :page-size="item.goodsPageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="item.itemInfos ? item.itemInfos.length:0"
        :current-page="item.goodsPageNo"
        background
        @current-change="e => handleCurrentChange(e, index)"
        @size-change="e => handleSizeChange(e, index)">
      </el-pagination>
    </el-card>
      <el-row class="action-bottom">
        <el-button @click="handleClose">返 回</el-button>
      </el-row>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'lookRebateRuleUse',
  components: { },
  data () {
    return {
      id: this.$route.query.id,
      detailData: { rules: [{}] }
    }
  },
  computed: {
  },
  mounted () {
    this.queryDetail()
  },
  methods: {
    ...mapActions(['usePolicyFindOneDm']),
    queryDetail () {
      this.usePolicyFindOneDm({ id: this.id }).then(res => {
        if (res.success) {
          this.detailData = res.data
          this.handleChangePage()
          this.handleChangeCustomer()
        }
      })
    },
    handleChangePage () {
      this.detailData.rules = this.detailData.rules.map(rule => {
        const goodsPageSize = rule.goodsPageSize || 10
        const goodsPageNo = rule.goodsPageNo || 1
        return {
          ...rule,
          goodsPageSize,
          goodsPageNo,
          showGoodsList: this.$lodash.cloneDeep(rule.itemInfos).splice(goodsPageSize * (goodsPageNo - 1), goodsPageSize)
        }
      })
    },
    // 分页条数变更
    handleSizeChange (val = 10, index) {
      this.detailData.rules[index].goodsPageSize = val
      this.detailData.rules[index].goodsPageNo = 1
      this.handleChangePage()
    },
    // 分页跳转
    handleCurrentChange (val = 1, index) {
      this.detailData.rules[index].goodsPageNo = val
      this.handleChangePage()
    },
    handleClose () {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.add-order{
  .input-width{
    width: 300px;
  }
  .form-item-inline{
    display: inline-block;
  }
  .form-title {
    font-weight: bold;
    margin-bottom: 20px;
    font-size: 15px;
  }
  .form-top, .form-card{
    margin-bottom: 15px;
  }
  .form-limit{
    margin-top: 8px;
  }
  .export-btn{
    float: right;
  }
  .action-bottom{
    margin-top: 20px;
  }
}
</style>
